import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { TAG_COLORS, TagColor } from '../../data/tag.model';
import { TAG_COLOR_CONFIG } from '../colors';

@Component({
  selector: 'dojo-tag-color-picker',
  template: `
    <div class="flex w-full items-center justify-between">
      @for (color of colors(); track color) {
        <button
          type="button"
          class="size-6 rounded-full"
          [class]="colorClasses()[color]"
          (click)="selectedColor.set(color)"
        ></button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagColorPickerComponent {
  readonly selectedColor = model<TagColor>('amber');
  readonly colors = input<readonly TagColor[]>(TAG_COLORS);

  readonly colorClasses = computed(() => {
    const selected = this.selectedColor();
    return Object.fromEntries(
      TAG_COLORS.map((color) => {
        const colorConfig = TAG_COLOR_CONFIG[color];
        const isSelected = color === selected;
        const classes = isSelected
          ? [colorConfig.solidClass, 'outline outline-1 outline-offset-2', colorConfig.outlineClass]
          : [colorConfig.solidClass, 'hover:outline hover:outline-1 hover:outline-offset-2 hover:outline-neutral-200'];
        return [color, classes.join(' ')];
      }),
    ) as Record<TagColor, string>;
  });
}
